import { Box, Paper, useTheme } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import Header from "./Header";
import ErrorAlert from "./ErrorAlert";
import CompanyBlockWarnings from "./CompanyBlockWarnings";

type PageContainerProps = {
  title: string;
  error?: string;
  guard?: () => boolean;
};

const PageContainer: FC<PropsWithChildren<PageContainerProps>> = ({
  title,
  error,
  guard = () => true,
  children,
}): JSX.Element => {
  const theme = useTheme();

  return (
    <Box>
      <Header title={title} />

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        padding="1rem"
      >
        <Paper
          variant="elevation"
          sx={{
            padding: { xs: "1rem", md: "1.5rem" },
            width: { xs: "95%", md: "85%", xl: "80%" },
            maxWidth: 1440,
            boxShadow:
              theme.palette.mode === "dark"
                ? "0px 4px 32px 8px rgba(0,0,0,0.45)"
                : "0px 4px 64px 16px rgba(255,231,219,0.9)",
            transition: "box-shadow 0.3s ease-in-out",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <ErrorAlert fill error={error ?? ""} />
          <CompanyBlockWarnings />

          {guard() ? (
            <>{children}</>
          ) : (
            <ErrorAlert
              fill
              hideTitle
              error="Você não tem as permissões necessárias para acessar esse recurso, caso precise de acesso ao mesmo por favor entre em contato com o suporte do sistema"
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default PageContainer;
